import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios"; import Cookies from "js-cookie";
import moment from "moment";
import {addLocale, locale} from "primereact/api";
import {InputText} from "primereact/inputtext";

const AuditlogListComponent = (props) => {
  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [instances, setInstances] = useState([]);
  const [auditlog, setAuditlog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('auditlog_first')) || 0,
    rows: Number(localStorage.getItem('auditlog_rows')) || rows,
    page: Number(localStorage.getItem('auditlog_page')) || 0,
    sortField: localStorage.getItem('auditlog_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('auditlog_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('auditlog_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "unified-audit-log" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setAuditlog(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', auditlogSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', auditlogSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm  p-button-secondary"
                tooltip={t('show')}
                tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  navigate('/auditlog/read/' + rowData.id)
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('auditlog_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('auditlog_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('auditlog_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('auditlog_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('auditlog_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('auditlog_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "login-select",
      {email: "superadmin@felhomatrac.eu"},
      {
        params: {},
        headers: {
          // 'Authorization': 'Bearer ' + Cookies.get("userToken"),
          // "Sys-name": Cookies.get("instanceId"),
          // "Preferred-locale": Cookies.get("language")
        }
      })
      .then(response => {
        setInstances(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [lazyParams, window.App.state.rerenderAuditlogList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('auditlog_list')}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
          {localStorage.getItem('auditlog_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('auditlog_filters')
                 localStorage.removeItem('auditlog_sortField')
                 localStorage.removeItem('auditlog_sortOrder')
                 localStorage.removeItem('auditlog_rows')
                 localStorage.removeItem('auditlog_page')
                 localStorage.removeItem('auditlog_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('auditlog_filters')
                             localStorage.removeItem('auditlog_sortField')
                             localStorage.removeItem('auditlog_sortOrder')
                             localStorage.removeItem('auditlog_rows')
                             localStorage.removeItem('auditlog_page')
                             localStorage.removeItem('auditlog_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
          <Dropdown  options={instances}
                    className={"p-ml-2"}
                    optionLabel="system_name_slugged"
                    optionValue="system_name_slugged"
                    filter
                    id={"sysname"}
                    emptyMessage={t('empty_message')}
                    onChange={(e) => {
                      Cookies.remove('instanceId', {
                        path: '/',
                        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                      });
                      Cookies.remove('instanceName', {
                        path: '/',
                        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                      });
                      Cookies.set('instanceId', e.value, {
                        expires: 7,
                        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
                        sameSite: 'Strict',
                        path: '/',
                        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                      });
                      Cookies.set('instanceName', e.value, {
                        expires: 7,
                        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
                        sameSite: 'Strict',
                        path: '/',
                        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                      });
                      loadLazyData();
                    }}
                    value={Cookies.get("instanceId")}
          />
        </div>
      </div>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={auditlog} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if(!rowData.data.deleted_at_snapshot)
          navigate('/auditlog/read/' + rowData.data.id)
        }}
      >
        
        <Column field="blame_user" sortable header={t('user')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="source_table" sortable header={t('source_table')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}
                body={rowData => {
                  return(
                    <>
                      {/*<i className={"pi pi-window-maximize"}*/}
                      {/*   onClick={(e) => {*/}
                      {/*     navigate('/' + rowData?.source_table?.replace('_audit', '') + '/' + rowData.object_id + '/update/')*/}
                      {/*   }}*/}
                      {/*></i>*/}
                      {/*&nbsp;*/}
                      {t(rowData?.source_table?.replace('_audit', ''))}
                      &nbsp;
                      {rowData.object_id}
                    </>
                  )
                }}
        ></Column>
        <Column field="type" sortable header={t('type')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="performed_at" sortable header={t('performed_at')}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
          if (rowData.performed_at !== null) {
            return (
              <span>{moment.utc(rowData.performed_at).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
            )
          }
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(AuditlogListComponent);
